module.exports = __webpack_public_path__ + "img/login.e4f1eb9c.png";